import React from 'react';
import PropTypes from 'prop-types';
import CustomProvider from 'components/CustomProvider';
import RedemptionHeader from './RedemptionHeader';
import RedemptionForm from './RedemptionForm';
import FrequentlyAskedQuestions from '../GiftFlow/Landing/FrequentlyAskedQuestions';
import { container } from './styles/styles.module.scss';

const RedemptionPage = ({ context }) => (
  <CustomProvider>
    <div className={container}>
      <RedemptionHeader />
      <RedemptionForm currencyCode={context.currencyCode} couponCode={context.couponCode} />
      <FrequentlyAskedQuestions />
    </div>
  </CustomProvider>
);

export default RedemptionPage;

RedemptionPage.propTypes = {
  context: PropTypes.shape({
    couponCode: PropTypes.string,
    currencyCode: PropTypes.string
  })
};

RedemptionPage.defaultProps = {
  context: PropTypes.shape({
    couponCode: null,
    currencyCode: null
  })
};
